import { ArrowRight, MapPin } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1598586958772-8bf368215c2a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwzfHxtb2RpZmllZCUyMG5lb24lMjBzcG9ydHMlMjBjYXIlMjBkYXJrfGVufDB8fHx8MTc4Mjc5Mjc0M3ww&ixlib=rb-4.1.0&q=85";

export const Hero = () => (
  <section id="hero" data-testid="hero-section" className="relative min-h-screen flex items-center">
    <div
      className="absolute inset-0 bg-cover bg-center"
      style={{ backgroundImage: `url(${HERO_IMG})` }}
    />
    <div className="absolute inset-0 bg-gradient-to-r from-black/95 via-black/75 to-black/40" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent" />

    <div className="relative max-w-7xl mx-auto px-6 lg:px-8 w-full pt-32 pb-24">
      <div className="max-w-3xl">
        <div className="flex items-center gap-3 mb-8">
          <span className="h-px w-12 bg-[#FF4500]" />
          <span className="text-sm uppercase tracking-[0.3em] text-[#FF4500] font-semibold">
            Custom Shop · 318 Logan Avenue
          </span>
        </div>
        <h1 className="font-heading text-5xl sm:text-6xl md:text-7xl font-bold tracking-tighter uppercase text-white leading-[0.95]">
          Jatt Car Modification:
          <br />
          <span className="text-[#FF4500]">Turn Heads</span> on Every Street
        </h1>
        <p className="mt-8 text-base md:text-lg text-neutral-300 leading-relaxed max-w-xl">
          Premium upgrades, flawless detailing, and aggressive custom builds.
          From body kits to ceramic coating — we make your ride impossible to ignore.
        </p>
        <div className="mt-12 flex flex-col sm:flex-row gap-4">
          <a
            href="#inquiry"
            data-testid="hero-quote-btn"
            className="group inline-flex items-center justify-center gap-3 bg-[#FF4500] text-white font-bold uppercase tracking-wider py-4 px-8 border border-[#FF4500] hover:bg-transparent hover:text-[#FF4500] transition-all duration-300"
          >
            Get a Free Quote
            <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
          </a>
          <a
            href="#visit"
            data-testid="hero-visit-btn"
            className="inline-flex items-center justify-center gap-3 bg-transparent text-white font-bold uppercase tracking-wider py-4 px-8 border border-neutral-700 hover:border-[#FF4500] hover:text-[#FF4500] transition-all duration-300"
          >
            <MapPin size={18} />
            Visit the Shop
          </a>
        </div>
        <div className="mt-16 grid grid-cols-3 gap-6 max-w-md">
          {[
            ["500+", "Builds Done"],
            ["10+", "Yrs Experience"],
            ["5★", "Rated Shop"],
          ].map(([num, label]) => (
            <div key={label} className="border-l-2 border-[#FF4500] pl-4">
              <div className="font-heading text-3xl font-bold text-white">{num}</div>
              <div className="text-xs uppercase tracking-widest text-neutral-500 mt-1">{label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
